import React, {Component} from 'react';
import {
    TextField,
    Dialog,
    DialogContent,
    FormControl,
    InputLabel,
    Input,
    Icon,
    Button,
    IconButton,
    Typography,
    DialogActions,
    Toolbar,
    AppBar,
    Avatar,
    InputAdornment
} from '@material-ui/core';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import {ToggleButton, ToggleButtonGroup} from '@material-ui/lab';
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import {UecareDropdown, UecareInput} from '../../../../components';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxGroup from '../../../../store/actionreducers/group';
import ReduxVip from '../../../../store/actionreducers/vip';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {connect} from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import {constDataDialogs} from "../../../../constants";

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    formControl: {
        marginBottom: 24
    },
});

const initNewVipState = {
    group: {
        type: {
            name: '個人會員'
        }
    },
    user: {
        family_name: '司馬',
        given_name: '天',
        nickname: '天天',
        cell_phone_no: '0981-254-361',
        id_no: 'E251965834',
        email: `water-${new Date().getTime()}@gmail.com`,
        password: '781026',
        sex: '女',
        birthday: moment().format('YYYY-MM-DD'),
        avatar: {url: 'https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png'},
    },
    habit: '每天跑步',
    ill_history: '腳扭傷'
};

const initControllerState = {
    show_password: false,
    is_password_edited: false,
    company: {id: 0},
    groupType: {label: 'person'},
    group_first_vip: '是'
};

class CompanyVipDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {vip: initNewVipState, ...initControllerState};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        /**
         * no vipDialog , no data need to resolve
         */
        if (!this.props.vipDialog) return;

        /**
         * After Dialog Open
         */
        if (!prevProps.vipDialog || (!prevProps.vipDialog.props.open && this.props.vipDialog.props.open)) {
            /**
             * Dialog type: 'edit'
             * Update State
             */
            if (this.props.vipDialog.type === 'edit' &&
                this.props.vip &&
                !_.isEqual(this.props.vip, prevState.vip)) {

                const company = (this.props.company && this.props.company.id) ? this.props.company : this.props.vip.group.company;

                this.setState({
                    vip: this.props.vip, ...initControllerState,
                    groupType: this.props.companyGroupType,
                    company,
                });
            }

            /**
             * Dialog type: 'new'
             * Update State
             */
            if (this.props.vipDialog.type === 'new') {
                _.set(initNewVipState, 'user.email', `water-${new Date().getTime()}@gmail.com`);
                _.set(initNewVipState, 'user.name', initNewVipState.user.family_name + initNewVipState.user.given_name);
                this.setState({
                    vip: initNewVipState, ...initControllerState,
                    groupType: this.props.companyGroupType,
                    company: this.props.company || initControllerState.company
                });
            }
        }
    }

    _getGroups = () => {
        if (this.state.groupType.label === 'company' && this.props.company) {
            return this.props.groups.filter((group) => {
                return group.company && (group.company.id === this.props.company.id);
            });
        } else return this.props.groups.filter((group) => {
            return group.type.label === this.state.groupType.label;
        });
    };

    handleClickShowPassword = () => {
        const password = (this.state.is_password_edited) ? this.state.vip.user.password : '';
        this.setState(state => ({
            show_password: !state.show_password,
            is_password_edited: true,
            vip: {...this.state.vip, user: {...this.state.vip.user, password}}
        }));
    };

    handleDropDownChange = (name, value) => {
        this.setState({[name]: value});
    };

    handleVipChange = (event) => {
        const newVip = {...this.state.vip, [event.target.name]: event.target.value};
        this.setState({vip: newVip});
    };

    handleChange = (event) => {
        const newVip = {...this.state.vip, user: {...this.state.vip.user, [event.target.name]: event.target.value}};
        const is_password_edited = (event.target.name === 'password') ? true : this.state.is_password_edited;
        newVip.user.name = newVip.user.family_name + newVip.user.given_name;
        this.setState({vip: newVip, is_password_edited});
    };

    closeDataDialog = () => {
        this.props.closeDataDialog({name: constDataDialogs.name.vipDialog});
    };

    _updateMainVip = async (vip, group) => {
        const updateGroupMainVip = this.props.updateGroupMainVip;
        if (this.state.group_first_vip === '是' && this.state.groupType.label !== 'person') {
            try {
                await updateGroupMainVip(vip, group);
            } catch (e) {
                console.warn('you got an error = ', e);
            }
        }
    };

    _isBlank(str) {
        return (!str || /^\s*$/.test(str));
    }

    canBeSubmitted() {
        // companyVip 只有可能有 company 類別
        if (!this.state.company) return false;
        else if (this.state.vip.group.fk_company_id !== this.state.company.id) return false;
        else return !this._isBlank(this.state.vip.user.name) && !this._isBlank(this.state.vip.user.password);
    }

    render() {
        const {classes, companies, vipDialog, groupTypes} = this.props;
        const {addVip, getVips, updateVip, disableVip, openLoadingMask, closeLoadingMask} = this.props;

        if (!vipDialog || vipDialog.props.open === false) return <div/>;

        return (
            <Dialog className={classes.root} {...vipDialog.props} onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            {vipDialog.type === 'new' ? '新的會員資料' : '會員資料'}
                        </Typography>
                    </Toolbar>
                    <div className="flex flex-col items-center justify-center pb-24">
                        <Avatar className="w-96 h-96" alt="contact avatar" src={this.state.vip.user.avatar.url}/>
                        {vipDialog.type === 'edit' && (
                            <Typography variant="title" color="inherit" className="pt-8">
                                {this.state.vip.user.name}
                            </Typography>
                        )}
                    </div>
                </AppBar>

                <DialogContent classes={{root: "p-24"}}>

                    <UecareInput
                        label='姓'
                        icon='account_circle'
                        name='family_name'
                        id='family_name'
                        className={classes.formControl}
                        value={this.state.vip.user.family_name || ''}
                        onChange={this.handleChange}/>

                    <UecareInput
                        label='名'
                        name='given_name'
                        id='given_name'
                        className={classes.formControl}
                        value={this.state.vip.user.given_name || ''}
                        onChange={this.handleChange}/>

                    <UecareInput
                        label='暱稱'
                        icon='star'
                        name='nickname'
                        id='nickname'
                        className={classes.formControl}
                        value={this.state.vip.user.nickname || ''}
                        onChange={this.handleChange}/>

                    <UecareDropdown
                        disabled
                        label='VIP類型'
                        icon='star'
                        name='groupTypeId'
                        id='groupType'
                        className={classes.formControl}
                        value={this.props.companyGroupType && this.props.companyGroupType.id}
                        options={groupTypes}/>

                    <UecareDropdown
                        disabled
                        label='企業'
                        icon='business'
                        name='companyId'
                        id='company'
                        className={classes.formControl}
                        value={this.state.company.id || 0}
                        options={companies}/>

                    <UecareDropdown
                        label='帳戶'
                        icon='group'
                        name='groupId'
                        id='group'
                        options={this._getGroups()}
                        className={classes.formControl}
                        value={(this.state.vip.group && this.state.vip.group.id) || 0}
                        onChange={(event, selectedOption) => {
                            this.handleVipChange({target: {name: 'group', value: selectedOption}});
                            this.handleDropDownChange('group', selectedOption);
                        }}/>

                    <UecareInput
                        label='手機號碼'
                        icon='phone'
                        name='cell_phone_no'
                        id='cell_phone_no'
                        className={classes.formControl}
                        value={this.state.vip.user.cell_phone_no || ''}
                        onChange={this.handleChange}/>

                    <UecareInput
                        label='身分證字號'
                        icon='picture_in_picture'
                        name='id_no'
                        id='id_no'
                        className={classes.formControl}
                        value={this.state.vip.user.id_no || ''}
                        onChange={this.handleChange}/>

                    <UecareInput
                        label='探視地址'
                        icon='place'
                        name='visit_address'
                        id='visit_address'
                        className={classes.formControl}
                        value={(this.state.vip.visit_address && this.state.vip.visit_address.address) || ''}
                        onChange={(event) => {
                            this.handleVipChange({
                                target: {
                                    name: 'visit_address',
                                    value: {address: event.target.value}
                                }
                            });
                        }}/>

                    <UecareInput
                        label='習慣'
                        icon='favorite'
                        name='habit'
                        id='habit'
                        className={classes.formControl}
                        value={this.state.vip.habit || ''}
                        onChange={this.handleVipChange}/>

                    <UecareInput
                        label='病史'
                        icon='assignment'
                        name='ill_history'
                        id='ill_history'
                        className={classes.formControl}
                        value={this.state.vip.ill_history || ''}
                        onChange={this.handleVipChange}/>

                    <UecareInput
                        label='Email'
                        icon='email'
                        name='email'
                        id='email'
                        className={classes.formControl}
                        value={this.state.vip.user.email}
                        onChange={this.handleChange}/>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">lock</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel htmlFor="password">密碼</InputLabel>
                            <Input
                                id="password"
                                name="password"
                                type={this.state.show_password ? 'text' : 'password'}
                                value={this.state.vip.user.password || ''}
                                onChange={this.handleChange}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Toggle password visibility"
                                            onClick={this.handleClickShowPassword}
                                        >
                                            {this.state.show_password ? <Visibility/> : <VisibilityOff/>}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">wc</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel htmlFor="sex">性別</InputLabel>
                            <Input id="sex" name="sex" value={this.state.vip.user.sex} disabled/>
                        </FormControl>
                        <ToggleButtonGroup exclusive value={this.state.vip.user.sex} onChange={this.handleChange}>
                            <ToggleButton value={{target: {name: 'sex', value: '男'}}}>
                                <FontAwesomeIcon icon="male"/>
                            </ToggleButton>
                            <ToggleButton value={{target: {name: 'sex', value: '女'}}}>
                                <FontAwesomeIcon icon="female"/>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">cake</Icon>
                        </div>
                        <TextField
                            id="birthday"
                            name="birthday"
                            label="生日"
                            type="date"
                            className={classes.formControl}
                            InputLabelProps={{
                                shrink: true
                            }}
                            value={this.state.vip.user.birthday}
                            onChange={this.handleChange}
                        />
                    </div>

                </DialogContent>

                {
                    (!this.state.vip.id) ? <div/>
                        :
                        (
                            vipDialog.type === 'new' ?
                                (
                                    <DialogActions className="justify-between pl-16">
                                        <Button
                                            variant="raised"
                                            color="primary"
                                            disabled={!this.canBeSubmitted()}
                                            onClick={async () => {
                                                try {
                                                    openLoadingMask();
                                                    await addVip(this.state.vip);
                                                    await getVips();
                                                    closeLoadingMask();
                                                    this.closeDataDialog();
                                                } catch (e) {
                                                    console.warn('you got an error = ', e);
                                                }
                                            }}
                                        >
                                            新增
                                        </Button>
                                    </DialogActions>
                                )
                                : (
                                    <DialogActions className="justify-between pl-16">
                                        <Button
                                            variant="raised"
                                            color="primary"
                                            disabled={!this.canBeSubmitted()}
                                            onClick={async () => {
                                                try {
                                                    openLoadingMask();
                                                    await updateVip(this.state.vip);
                                                    await getVips();
                                                    closeLoadingMask();
                                                    this.closeDataDialog();
                                                } catch (e) {
                                                    console.warn('you got an error = ', e);
                                                }
                                            }}
                                        >
                                            修改
                                        </Button>
                                        <IconButton
                                            onClick={async () => {
                                                try {
                                                    await disableVip(this.state.vip.id); // disable VIP
                                                    this.closeDataDialog();
                                                } catch (e) {
                                                    console.warn('you got an error = ', e);
                                                }
                                            }}
                                        >
                                            <Icon>delete</Icon>
                                        </IconButton>
                                    </DialogActions>
                                )
                        )
                }

            </Dialog>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addVip: ReduxVip.ActionCreator.addVip,
        getVips: ReduxVip.ActionCreator.getVips,
        updateVip: ReduxVip.ActionCreator.updateVip,
        disableVip: ReduxVip.ActionCreator.disableVip,
        updateGroupMainVip: ReduxGroup.ActionCreator.updateMainVip,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
    }, dispatch);
}

function mapStateToProps({global: {dataDialogs}, group: {groups}, company: {company, companies}, vip: {vip, vips}, groupType}) {

    const companyGroupType = groupType.list.find((groupType) => {
        return groupType.label === 'company';
    });

    return {
        vipDialog: dataDialogs[constDataDialogs.name.vipDialog],
        groups,
        companies,
        company,
        vip,
        vips,
        groupTypes: groupType.list,
        companyGroupType
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(CompanyVipDialog));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/companyVip/CompanyVipDialog.js